import React, { Component } from 'react'
import { 
  Button,
  FormGroup, 
  InputGroup,
  Dialog,
  Classes,
  Switch
} from "@blueprintjs/core"
import Alert from '../../../Alert'
import is from 'is_js'

import './styles.css'

class CategoryDialog extends Component {
    constructor(props){
      super(props)
      this.state = {
        visible: false,
        exclude: true
      }

      this.onConfirm = this.onConfirm.bind(this)
      this.show = this.show.bind(this)
      this.hide = this.hide.bind(this)
    }

    show(){
      this.setState({
        visible: true
      })
    }

    hide(){
      this.setState({
        visible: false
      })
    }

    onConfirm(){
      const exclude = !!this.exclude && !this.exclude.checked
      const category = this[this.props.type].value

      if(is.empty(category.replace(/\s+/g, ''))){
        this.error.show()
      }else{
        this.hide()
        this.props.onConfirm && this.props.onConfirm(category.trim(), exclude)
      }
    }

    render() {
      return(
         <Dialog
          isOpen={this.state.visible}
          backdropProps={{
            onClick: this.hide,
            style: {
              cursor: 'pointer'
            }
          }}
          className="bp3-dark input-modal">
          <Alert 
            confirm
            body={`Enter a ${this.props.type} name`}
            ref={(error)=>(this.error = error)}
          />
          <div className={Classes.DIALOG_BODY}>
            <div className="grid-center-middle">
              <div className="col-10">
                <FormGroup
                  label={`Input ${this.props.type}`}
                  labelFor="category-input">
                  <InputGroup 
                    inputRef={(input)=>(
                      this[this.props.type] = input
                    )}
                    defaultValue={this.props.defaultValue}
                    id="category-input" 
                    placeholder={(this.props.type || '').charAt(0).toUpperCase() + (this.props.type || '').slice(1)}
                  />
                </FormGroup>
              </div>
              <div className="col-2">
                <Button minimal="true" 
                  className="button button-primary" 
                  onClick={this.onConfirm}>
                  {this.props.edit != '' ? 'Save' : 'Add'}
                </Button>
              </div>
            </div>
            <div>
              {!this.props.disabledExclude && (
                <Switch
                  className='categoryExclude'
                  defaultChecked={!this.props.exclude} 
                  label='Use in Communication Strategy' 
                  inputRef={(exclude)=>(this.exclude = exclude)} 
                />
              )}
            </div>
          </div>
        </Dialog>
      )
    }
}

export default CategoryDialog



// WEBPACK FOOTER //
// ./src/components/Shared/SidebarContent/components/CategoryDialog/index.js